import { ModalComponent } from "../../..";
import { SingleCooperativeDetails } from "../../../../../redux/features/cooperative/cooperative.type";
import { RequestLoanFlow } from "./flow";

export const RequestLoanModal = ({
  modalOpen,
  onModalClose,
  cooperativeDetails,
  onSuccess,
}: {
  modalOpen: boolean;
  onModalClose: () => void;
  cooperativeDetails: SingleCooperativeDetails;
  onSuccess: () => void;
}) => {
  return (
    <ModalComponent
      isModalOpen={modalOpen}
      onModalClose={() => {
        onModalClose();
      }}
      topTitle
      title="Loan Request"
      subTitle=""
      modalClassName=""
      childrenClassName={"flex flex-col"}
      hasButtons={false}
      modalStyle="side"
      showMobileTopBar={false}
    >
      <RequestLoanFlow
        cooperativeDetails={cooperativeDetails}
        onSuccess={onSuccess}
      />
    </ModalComponent>
  );
};
